<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      accessToken: null,
      refreshToken: null,
    };
  },
  created() {
    this.handleToken();
  },
  methods: {
    handleToken() {
      // Obtener el token desde la URL
      const urlParams = new URLSearchParams(window.location.search);
      this.accessToken = urlParams.get('token');

      if (this.accessToken) {
        // Guardar el token en localStorage
        localStorage.setItem('accessToken', this.accessToken);

        // Limpiar el token de la URL y redirigir al componente SidebarItems
        this.$router.push({ name: 'MainPage' });
      } else {
        // Redirigir al componente de inicio de sesión si no está autenticado
        this.redirectToLogin();
      }
    },
    redirectToLogin() {
      this.$router.push({ name: 'LoginPage' });
    }
  }
};
</script>

<style scoped>
#app {
  display: block;
}

.content {
  width: 100%;
  min-width: 400px;
  padding: 1rem;
}

/* Media query para pantallas pequeñas */
@media (max-width: 600px) {
  #app {
    flex-direction: column; /* Cambia la dirección del flex a columna */
  }

  .content {
    margin-left: 0; /* Elimina el margen izquierdo */
    min-width: 100%; /* Asegura que el contenido ocupe todo el ancho disponible */
  }

  .sidebar {
    display: none; /* Oculta la barra lateral */
  }
}
</style>